import { render, staticRenderFns } from "./AdministratorDashboard.vue?vue&type=template&id=2349d548&"
import script from "./AdministratorDashboard.vue?vue&type=script&lang=ts&"
export * from "./AdministratorDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AdministratorDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports